import { useState } from "react";
import { Box, AppBar, Tabs, Tab, IconButton } from "@mui/material";
import MobileExplore from "./MobileExplore";
import MobileCustomize from "./MobileCustomize";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useParams } from "react-router-dom";
import {
  useGetProductDataById,
  useSetActionCall,
} from "../../modules/services";

export default function MobileMain() {
  const [tab, setTab] = useState("explore");

  const [rotate, setRotate] = useState(false);
  const { id } = useParams();
  const { data } = useGetProductDataById(id);
  const { mutate: sendRotateCall } = useSetActionCall();
  const { mutate: sendInteractionCall } = useSetActionCall();

  const controlData = data?.data?.showcase?.controls;
  const productData = data?.data?.showcase?.products;
  const environmentData = data?.data?.showcase?.environment;
  const mainTitle = data?.data?.showcase?.display_title;
  const modelTitle = data?.data?.showcase?.display_sub_title;
  const accessoriesData = productData?.[0]?.accessories;
  const productKey = productData?.[0]?.product_key;
  const productInfo = productData?.[0]?.additional_info;
  const actData = data?.data?.showcase?.acts;
  const interactionsData = data?.data?.showcase?.interactions;

  const controlId = data?.data?.showcase?.controls?.[0]?.control_id;

  const showcaseId = data?.data?.showcase?.showcase_id;
  const sessionId = data?.data?.sessionID;

  const handleTabChange = (_, newValue) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {/* Tabs rendered in Main */}
      <AppBar position="static" color="default" elevation={1}>
        <Box sx={{ display: "flex", alignItems: "center", p: 1 }}>
          <IconButton>
            <ArrowBackIcon />
          </IconButton>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab value="explore" label="Explore" />
            <Tab value="customize" label="Customize" />
          </Tabs>
        </Box>
      </AppBar>

      {/* Content area */}
      <Box sx={{ height: "calc(100vh - 48px)", overflowY: "auto" }}>
        {tab === "explore" ? (
          <MobileExplore
            onCustomizeClick={() => setTab("customize")}
            sessionId={sessionId}
            showcaseId={showcaseId}
            mainTitle={mainTitle}
            modelTitle={modelTitle}
            productData={productData}
          />
        ) : (
          <MobileCustomize
            sessionId={sessionId}
            showcaseId={showcaseId}
            productData={productData}
            mainTitle={mainTitle}
            modelTitle={modelTitle}
          />
        )}
      </Box>
    </Box>
  );
}
